import avatarMessages from "../Avatar/messages";
import { messages as userDisplayNameWithInfoMessages } from "../Avatar/util/getUserDisplayNameWithInfo";
import colorComponentsMessages from "../colorComponents/messages";
import commonMessages from "../common/messages";
import emailBodyToolbarMessages from "../email/EmailBody/component/Toolbar/messages";
import emailBodyMessages from "../email/EmailBody/messages";
import emailDynamicVariablesViewMessages from "../email/EmailDynamicVariableView/messages";
import emailRecipientListMessages from "../email/EmailRecipientList/messages";
import emailSubjectInputMessages from "../email/EmailSubject/messages";
import entityFieldSelectorMessages from "../EntityFieldSelector/messages";
import inputMessages from "../input/messages";
import modalMessages from "../Modal/messages";
import popconfirmMessages from "../Popconfirm/messages";
import { messages as teamMultiSelectMessages } from "../TeamMultiSelectField";
import { messages as teamPickerMessages } from "../TeamPicker";
import { messages as userPickerMessages } from "../UserPicker";
import visibilitySelectorMessages from "../VisibilitySelector/messages";

const messages = {
  ...avatarMessages,
  ...colorComponentsMessages,
  ...commonMessages,
  ...emailBodyMessages,
  ...emailBodyToolbarMessages,
  ...emailDynamicVariablesViewMessages,
  ...emailRecipientListMessages,
  ...emailSubjectInputMessages,
  ...entityFieldSelectorMessages,
  ...inputMessages,
  ...modalMessages,
  ...popconfirmMessages,
  ...teamMultiSelectMessages,
  ...teamPickerMessages,
  ...userDisplayNameWithInfoMessages,
  ...userPickerMessages,
  ...visibilitySelectorMessages,
} as const;

export type MessageKey = keyof typeof messages;

export default messages;
